import { Component } from '@angular/core';

@Component({
  selector: 'fnsr-faq',
  standalone: true,
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {
}
